import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation CustomerAttributeListPage_UpdateCustomerAttributeOrderIndexes(
    $customerAttributeGroupId: ID!
    $input: [OrderIndexInput!]!
  ) {
    updateCustomerAttributeOrderIndexes(
      customerAttributeGroupId: $customerAttributeGroupId
      input: $input
    ) {
      result
    }
  }
`)

export const useSortCustomerAttributesMutation = (
  options: Omit<
    UseMutationOptions<
      ResultOf<typeof document>,
      unknown,
      VariablesOf<typeof document>,
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (variables) => graphQLRequest({ document, variables }),
    ...options,
  })
}
